import { AttributesTabsModel, CategoriesTabsModel, NotificationTabsModel, OrganizationStructureTabsModel } from "../models";


export const ATTRIBUTE_COMPONENTS: AttributesTabsModel[] = [
    {
        id: 'attributes',
        name: {
            ru: 'Атрибуты',
            en: 'Attributes',
            kk: 'Атрибуты'
        }
    },
    {
        id: 'attributes-groups',
        name: {
            ru: 'Группы атрибутов',
            en: 'Attributes groups',
            kk: 'Группы атрибутов'
        }
    },
    {
        id: 'references',
        name: {
            ru: 'Справочники',
            en: 'References',
            kk: 'Справочники'
        }
    },
    // {
        // id: 'presets',
        // name: {
        //     ru: 'Пресеты',
        //     en: 'Presets',
        //     kk: 'Пресеты'
        // }
    // }
]

export const NOTIFICATIONS_COMPONENTS: NotificationTabsModel[] = [
    {
        id: 'roles_notifications',
        name: {
            ru: 'Уведомления(выбор роли)',
            en: 'Notification(role)',
            kk: 'Уведомления(выбор роли)'
        }
    },
    // {
    //     id: 'channel_notifications',
    //     name: {
    //         ru: 'Уведомления(выбор канала)',
    //         en: 'Notifications(channel)',
    //         kk: 'Уведомления(выбор канала)'
    //     }
    // }
]

export const ORGANIZATION_STRUCTURE_COMPONENTS: OrganizationStructureTabsModel[] = [
    {
        id: 'positions',
        name: {
            ru: 'Список должностей',
            en: 'Positions list',
            kk: 'Список должностей'
        }
    },
    {
        id: 'depatrments',
        name: {
            ru: 'Список отделов',
            en: 'Departments list',
            kk: 'Список отделов'
        }
    },
    {
        id: 'structures',
        name: {
            ru: 'Список структур организации',
            en: 'Organization structures list',
            kk: 'Список структур организации'
        }
    }
]

export const CATEGORIES_COMPONENTS: CategoriesTabsModel[] = [
    {
        id: 'categories',
        name: {
            ru: 'Товарные категории',
            en: 'Goods categories',
            kk: 'Товарные категории'
        }
    },
    {
        id: 'files_categories',
        name: {
            ru: 'Файловые категории',
            en: 'Files categories',
            kk: 'Файловые категории'
        }
    }
]